import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import SkelotonEffect from './SkelotonEffect';





const GenreRecommended = () => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const userId = localStorage.getItem('userid');
    const [error, setError] = useState(null);
    const [firstObject, setFirstObject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${baseURL}/homedata/?userid=${userId}&limit=100`, {
            headers: {
                'Authorization': apiKey,
                'accept': 'application/json'
            }
        })
            .then(response => {

                if (response.data.length > 0) {
                    setFirstObject(response.data[3]);
                   
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setError(error);
            })
            .then(() => {
                setIsLoading(false); // Set loading state to false when request completes
            });
    }, [userId, baseURL, apiKey]);

    const handleGenreClick = (genreID) => {
        navigate('/genre-books', { state: { genreID } });
    };

    


    return (
        <>
           
            {error ? (
                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />
                        
                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect /> // Show loading spinner while data is being fetched
            ) : (
                <div className='container'>
                    <div className='row my-4'>
                        <div className="col-md-12 px-0">
                            <NavLink to="/home" className="back-button" >
                                <i className="fas fa-long-arrow-alt-left"></i>
                            </NavLink>
                        </div>

                        {firstObject && (
                            <div className='col-md-12  mt_0 py-4 text-upper books_section'>
                                <h2 className='section-heading'>{firstObject.title}</h2>

                                <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                    {firstObject.cat_data && firstObject.cat_data.map(datav => (

                                        <div className='col' key={datav._id} onClick={() => handleGenreClick(datav._id)}>
                                            <div className="ag-courses_item">
                                                <div className="ag-courses-item_link">
                                                    <div className="ag-courses-item_bg">
                                                    </div>
                                                    <div className="ag-courses-item_title">
                                                        {datav.category_name}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ))

                                    }
                                </div>


                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default GenreRecommended;
